import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { UserMaster } from "types";
import { RootState } from "./root-store";
import { getCurrentUser } from "../firebase";
import { setUser } from "./session";

export const useCurrentUser = () => {
	return useSelector((state: RootState) => state.session.user);
};

/**
 * Intended to be used inside a protected route, where existence is certain
 */
export const useSafeCurrentUser = () => {
	return useSelector((state: RootState) => state.session.user as UserMaster);
};

export const useRefreshUser = (rootGoogleId?: string) => {
	const dispatch = useDispatch();
	return useCallback(
		(google_id?: string) => {
			if (!google_id && !rootGoogleId) {
				return;
			}

			getCurrentUser((google_id || rootGoogleId) as string).then((user) => {
				dispatch(setUser(user));
			});
		},
		[dispatch, rootGoogleId]
	);
};
